// britam-admin.ts
import { FormattedMessage } from 'react-intl';
import { IconDashboard, IconDeviceAnalytics, IconFileCheck, IconPencilPlus, IconFileX, IconSettings } from '@tabler/icons-react';
import { getUserRegionFromStorage } from 'Application/utils';

const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconFileCheck,
    IconPencilPlus,
    IconFileX,
    IconSettings
};

// Country-based menu item configuration
const countryMenuItems = {
    Kenya: {
        id: 'generateQuoteKenya',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-cse-bd/travel-portal/generate-quote',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    },
    Rwanda: {
        id: 'generateQuoteRwanda',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-cse-bd/travel-portal/generate-quote-rw',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    }
};
const userCountry = (getUserRegionFromStorage() ?? 'Kenya') as keyof typeof countryMenuItems;
const selectedCountryItem = countryMenuItems[userCountry];

export const BritamCSEBDHomeItem = {
    id: 'britam-cse-bd',
    title: <FormattedMessage id="Britam CSE/BD" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id="Home" />,
            type: 'item',
            url: '/britam-cse-bd/home',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const CSEBDTravelInsurance = {
    id: 'travelInsurance',
    title: <FormattedMessage id="Travel Insurance" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        selectedCountryItem, // Dynamically select based on userCountry
        {
            id: 'Completed Transactions',
            title: <FormattedMessage id="Completed Transactions" />,
            type: 'item',
            url: '/britam-cse-bd/travel-portal/completed-transactions',
            icon: icons.IconFileCheck,
            breadcrumbs: false
        },
        {
            id: 'Generated Quotes',
            title: <FormattedMessage id="Generated Quotes" />,
            type: 'item',
            url: '/britam-cse-bd/travel-portal/generated-quotes',
            icon: icons.IconFileX,
            breadcrumbs: false
        }
        // {
        //     id: 'travelPlans',
        //     title: <FormattedMessage id="Travel Plans" />,
        //     type: 'item',
        //     url: '/agency/travel-portal/travel-plans',
        //     icon: icons.IconPlane,
        //     breadcrumbs: false
        // }
    ]
};

export const BritamCSEBDProducts = {
    id: 'britam-products',
    title: <FormattedMessage id="Products" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-cse-bd-travel',
            title: <FormattedMessage id="Travel" />,
            icon: icons.IconDashboard,
            type: 'collapse',
            children: [
                // {
                //     id: 'britam-cse-bd-travel-setup',
                //     title: <FormattedMessage id="Setup" />,
                //     type: 'item',
                //     url: '/britam-cse-bd/products/travel/setup',
                //     breadcrumbs: false,
                // },
                {
                    id: 'britam-cse-bd-travel-reports',
                    title: <FormattedMessage id="Reports" />,
                    type: 'item',
                    url: '/britam-cse-bd/products/travel/reports',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export const BritamCSEBDAgencies = {
    id: 'britam-agencies',
    title: <FormattedMessage id="Agencies" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-agencies-agencies',
            title: <FormattedMessage id="Agencies" />,
            type: 'item',
            url: '/britam-cse-bd/agencies',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const CSEsupport = {
    id: 'support',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        // {
        //     id: 'support',
        //     title: <FormattedMessage id="Support" />,
        //     type: 'item',
        //     url: '/agency/support',
        //     icon: icons.IconHelpHexagon,
        //     breadcrumbs: false
        // },
        {
            id: 'Settings',
            title: <FormattedMessage id="Settings" />,
            type: 'item',
            url: '/britam-cse-bd/settings',
            icon: icons.IconSettings,
            breadcrumbs: false
        }
    ]
};
